import { render } from "./BannerCluster.vue?vue&type=template&id=3c0145a8&ts=true"
import script from "./BannerCluster.ts?vue&type=script&lang=ts&external"
export * from "./BannerCluster.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__